export default function SupplierDiscountManagement() {

  return (
      <p>مدیریت تخفیف</p>
  );
};